import { useAuth } from '@/lib/auth/auth';
import { useWritableMarketMutation } from '@/features/market/useWritableMarketMutation';
import {
  applySavedVenueDealOptimisticUpdate,
  invalidateSavedVenueDealQueries,
  restoreSavedVenueDealSnapshot,
  toggleSavedVenueDealRequest,
} from './savedVenueDealMutation';
import type { VenuePublicDeal } from '@/lib/api/apiTypes';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useSavedVenueDeal(venueID: string) {
  const request = useAuth((state) => state.request);
  const queryClient = useQueryClient();

  return useWritableMarketMutation(
    useMutation({
      mutationFn: ({ deal }: { deal: VenuePublicDeal }) => toggleSavedVenueDealRequest(request, deal),
      onMutate: ({ deal }) => applySavedVenueDealOptimisticUpdate(queryClient, { deal, venueID }),
      onError: (_error, _variables, context) => {
        restoreSavedVenueDealSnapshot(queryClient, context);
      },
      onSettled: () => invalidateSavedVenueDealQueries(queryClient, venueID),
    })
  );
}
